import * as React from "react";
const SvgSelectedIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9 16.2L4.8 12L3.4 13.4L9 19L21 6.99998L19.6 5.59998L9 16.2Z", fill: "currentColor" }));
export default SvgSelectedIcon;
